// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_ed8703e9","gridWrapper":"_91fe12d1","tileWrapper":"_f9ece59d","isQuote":"_6486e1fa","shimmerLoadingBackground":"_ed231177"};